export default __webpack_public_path__ + "static/media/14.1535ba0b.png";